import { render, staticRenderFns } from "./RejectDialog.vue?vue&type=template&id=182c92ca&scoped=true&"
import script from "./RejectDialog.vue?vue&type=script&lang=ts&"
export * from "./RejectDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182c92ca",
  null
  
)

export default component.exports